var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.isBeneficiario
        ? _c(
            "el-row",
            [
              _c("el-row", { staticClass: "marginTop" }, [
                _c(
                  "div",
                  { staticClass: "margem" },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c("app-display", {
                          attrs: {
                            label: "Tipo de cadastro:",
                            content: _vm.tipo
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c("app-display", {
                          attrs: {
                            label: "Data de cadastro:",
                            content: this.dataCadastro
                          }
                        })
                      ],
                      1
                    ),
                    _vm.dataRetificacao
                      ? _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c("app-display", {
                              attrs: {
                                label: "Data de retifição:",
                                content: this.dataCadastro
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-row",
        [
          _vm.qualificacao
            ? _c("app-divider", { attrs: { label: "Qualificação" } })
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "marginTop" },
        [
          _vm.qualificacao
            ? _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "div",
                  { staticClass: "margem" },
                  [
                    _c("app-display", {
                      attrs: {
                        label: _vm.labelQualificacao.area,
                        content:
                          _vm.formatterDecimal(_vm.qualificacao.area) +
                          " hectare(s)"
                      }
                    }),
                    _vm.qualificacao.municipio
                      ? _c("app-display", {
                          attrs: {
                            label: "Município:",
                            content: _vm.qualificacao.municipio.nome
                          }
                        })
                      : _vm._e(),
                    _c("app-display", {
                      attrs: {
                        label: "Qual a renda familiar?",
                        content: _vm.renda
                      }
                    }),
                    _c("app-display", {
                      attrs: {
                        label: _vm.labelQualificacao.brasileiroNatoNaturalizado,
                        content: _vm.qualificacao.brasileiroNatoNaturalizado
                          ? "Sim"
                          : "Não"
                      }
                    }),
                    _c("app-display", {
                      attrs: {
                        label: _vm.labelQualificacao.cargoPublico,
                        content: _vm.qualificacao.cargoPublico ? "Sim" : "Não"
                      }
                    }),
                    _vm.qualificacao.cargoPublico
                      ? _c("app-display", {
                          attrs: {
                            label: _vm.labelQualificacao.dataAquisicaoImovel,
                            content: _vm.formatDate(
                              _vm.qualificacao.dataAquisicaoImovel
                            )
                          }
                        })
                      : _vm._e(),
                    _vm.qualificacao.cargoPublico
                      ? _c("app-display", {
                          attrs: {
                            label: _vm.labelQualificacao.dataPosseCargopublico,
                            content: _vm.formatDate(
                              _vm.qualificacao.dataPosseCargopublico
                            )
                          }
                        })
                      : _vm._e(),
                    _c("app-display", {
                      attrs: {
                        label: _vm.labelQualificacao.desintrusado,
                        content: _vm.qualificacao.desintrusado ? "Sim" : "Não"
                      }
                    }),
                    _c("app-display", {
                      attrs: {
                        label: _vm.labelQualificacao.contestacaoTerceiros,
                        content: _vm.qualificacao.contestacaoTerceiros
                          ? "Sim"
                          : "Não"
                      }
                    }),
                    _c("app-display", {
                      attrs: {
                        label: _vm.labelQualificacao.possuiImovelRuralTitulado,
                        content: _vm.qualificacao.possuiImovelRuralTitulado
                          ? "Sim"
                          : "Não"
                      }
                    }),
                    _c("app-display", {
                      attrs: {
                        label: _vm.labelQualificacao.ocupaImovel,
                        content: _vm.qualificacao.ocupaImovel ? "Sim" : "Não"
                      }
                    }),
                    _c("app-display", {
                      attrs: {
                        label: _vm.labelQualificacao.beneficiarioReformaAgraria,
                        content: _vm.qualificacao.beneficiarioReformaAgraria
                          ? "Sim"
                          : "Não"
                      }
                    }),
                    _c("app-display", {
                      attrs: {
                        label: _vm.labelQualificacao.cunhoRecreativo,
                        content: _vm.qualificacao.cunhoRecreativo
                          ? "Sim"
                          : "Não"
                      }
                    }),
                    _vm.qualificacao.cunhoRecreativo
                      ? _c("app-display", {
                          attrs: {
                            label: _vm.labelQualificacao.moradiaHabitual,
                            content: _vm.qualificacao.moradiaHabitual
                              ? "Sim"
                              : "Não"
                          }
                        })
                      : _vm._e(),
                    _c("app-display", {
                      attrs: {
                        label: _vm.labelQualificacao.trabalhoEscravo,
                        content: _vm.qualificacao.trabalhoEscravo
                          ? "Sim"
                          : "Não"
                      }
                    }),
                    _c("app-display", {
                      attrs: {
                        label: _vm.labelQualificacao.ocupantePrimitivo,
                        content: _vm.qualificacao.ocupantePrimitivo
                          ? "Sim"
                          : "Não"
                      }
                    }),
                    _vm.qualificacao.ocupantePrimitivo
                      ? _c("app-display", {
                          attrs: {
                            label: _vm.labelQualificacao.dataOcupacaoPrimitiva,
                            content: _vm.formatDate(
                              _vm.qualificacao.dataOcupacaoPrimitiva
                            )
                          }
                        })
                      : _c("app-display", {
                          attrs: {
                            label: _vm.labelQualificacao.dataOcupacaoPrimitiva,
                            content: _vm.formatDate(
                              _vm.qualificacao.dataOcupacaoPrimitiva
                            )
                          }
                        }),
                    _vm.qualificacao.transmitentes.length > 0
                      ? _c(
                          "el-row",
                          { attrs: { gutter: 30 } },
                          [
                            _c(
                              "el-table",
                              {
                                staticClass: "table",
                                attrs: {
                                  data: _vm.qualificacao.transmitentes,
                                  stripe: "stripe",
                                  "element-loading-text": "Carregando..."
                                }
                              },
                              [
                                _c("template", { slot: "empty" }, [
                                  _vm._v("Não há registros.")
                                ]),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "nome",
                                    label: "Nome do transmitente"
                                  }
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "dataOcupacaoAtual",
                                    label: "Data da ocupação",
                                    formatter: _vm.formatDate
                                  }
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "area",
                                    label: "Área",
                                    formatter: _vm.formatArea
                                  }
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "ocupantePrimitivo",
                                    label: "Ocupante primitivo?",
                                    formatter: _vm.formatOcupante
                                  }
                                })
                              ],
                              2
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _c("app-display", {
                      attrs: {
                        label: _vm.labelQualificacao.praticaCultutraEfetiva,
                        content: _vm.qualificacao.praticaCultutraEfetiva
                          ? "Sim"
                          : "Não"
                      }
                    }),
                    _c("span", { staticClass: "pessoas" }, [
                      _vm._v("Lista de pessoas que acompanham o processo")
                    ]),
                    _vm._l(_vm.pessoas, function(pessoa) {
                      return _c(
                        "div",
                        [
                          _c("app-display", {
                            attrs: { content: pessoa.nomeRazaoSocial }
                          })
                        ],
                        1
                      )
                    })
                  ],
                  2
                )
              ])
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f1c91a78", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f1c91a78","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/InformacoesQualificacaoRr.vue
// module id = null
// module chunks = 